(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mf7-trancher"] && !Shopify.designMode) return;
  try {
    
  /* Morfil (mf7) — « Regarde-les trancher » : vidéos lues seulement quand la carte est visible, points du carrousel */
  if (!customElements.get('mf7-trancher')) {
    class Mf7Trancher extends HTMLElement {
      connectedCallback() {
        this.liste = this.querySelector('[data-mf7-liste]');
        this.points = Array.from(this.querySelectorAll('[data-mf7-point]'));
        this.videos = Array.from(this.querySelectorAll('video[data-mf7-video]'));
        const moinsAnimations = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.lectureAuto === 'true' && !moinsAnimations && 'IntersectionObserver' in window) {
          this.observateur = new IntersectionObserver(
            (entrees) => {
              entrees.forEach((entree) => {
                if (entree.isIntersecting && entree.intersectionRatio >= 0.35) {
                  this.lancer(entree.target);
                } else {
                  entree.target.pause();
                }
              });
            },
            { threshold: [0, 0.35, 0.7] }
          );
          this.videos.forEach((video) => {
            video.muted = true;
            video.addEventListener('playing', () => video.setAttribute('data-mf7-joue', ''));
            this.observateur.observe(video);
          });
        }
        if (this.liste && this.points.length > 1) {
          this.surDefilement = () => {
            if (this.attente) return;
            this.attente = requestAnimationFrame(() => {
              this.attente = null;
              this.majPoints();
            });
          };
          this.liste.addEventListener('scroll', this.surDefilement, { passive: true });
        }
      }

      disconnectedCallback() {
        if (this.observateur) this.observateur.disconnect();
        if (this.liste && this.surDefilement) this.liste.removeEventListener('scroll', this.surDefilement);
      }

      lancer(video) {
        if (!video.dataset.mf7Charge) {
          video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
          });
          video.dataset.mf7Charge = '1';
          video.load();
        }
        const lecture = video.play();
        if (lecture && typeof lecture.catch === 'function') lecture.catch(() => {});
      }

      majPoints() {
        const items = this.liste.children;
        if (!items.length) return;
        const pas = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : items[0].offsetWidth;
        if (!pas) return;
        const maxi = this.liste.scrollWidth - this.liste.clientWidth;
        let index = Math.round(this.liste.scrollLeft / pas);
        if (this.liste.scrollLeft >= maxi - 2) index = this.points.length - 1;
        index = Math.max(0, Math.min(this.points.length - 1, index));
        this.points.forEach((point, i) => point.classList.toggle('is-actif', i === index));
      }
    }
    customElements.define('mf7-trancher', Mf7Trancher);
  }

  } catch(e) { console.error(e); }
})();
})();
